import Input from "antd/es/input";
import React from "react";
import TextArea from "antd/es/input/TextArea";

import EquipmentCategoryLookup from "@containers/Lookup/EquipmentCategoryLookup";
import Select from "@components/ResponsiveSelect";

const {Option} = Select;


export const EquipmentFormFields = [
    {
        title: 'key',
        name: 'id',
        order: 0,
        visible: false,
        length: 0,
        type: 'text',
    },
    {
        title: 'Name',
        name: 'name',
        order: 1,
        visible: true,
        length: "w-1/2",
        type: 'text',
        required: true,
        render: <Input/>
    },
    {
        title: 'Category',
        name: 'category',
        order: 7,
        visible: true,
        length: "w-1/2",
        type: 'Lookup_text',
        render: (value) => {
            return <EquipmentCategoryLookup value={value}/>
        }
    },
    {
        title: 'Service',
        name: 'service',
        order: 8,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },
    {
        title: 'Condition',
        name: 'condition',
        order: 5,
        visible: true,
        length: "w-1/2",
        type: 'text',
        required: true,
        initialValue: 'Null',
        render: <Select>
            <Option value="Null">Null</Option>
            <Option value="Excellent">Excellent</Option>
            <Option value="Good">Good</Option>
            <Option value="Fair">Fair</Option>
            <Option value="Poor">Poor</Option>
            <Option value="Failed">Failed</Option>
        </Select>
    },


    // {
    //     title: 'Tag',
    //     name: 'tag',
    //     order: 3,
    //     visible: true,
    //     length: "w-1/2",
    //     type: 'Tag',
    //     render: <TagInput/>
    // },
    {
        title: 'Building',
        name: 'building',
        order: 6,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },
    {
        title: 'Location',
        name: 'location',
        order: 6,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },

    {
        title: 'Install Date',
        name: 'install_date',
        order: 4,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input type={'date'}/>
    },

    // {
    //     title: 'Separator',
    //     name: 'Separator',
    // },

    {
        title: 'Manufacturer',
        name: 'Manufacturer',
        order: 6,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },
    {
        title: 'Equipment Model',
        name: 'Equipment_Model',
        order: 6,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },


    {
        title: 'Equipment SN',
        name: 'Equipment_SN',
        order: 6,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input/>
    },
    {
        title: 'Description',
        name: 'description',
        order: 2,
        visible: true,
        length: "w-full",
        type: 'textarea',
        render: <TextArea/>
    },
    {
        title: 'Equipment Score',
        name: 'equipment_score',
        order: 16,
        visible: true,
        length: "w-1/2",
        type: 'number',
        render: <Input disabled/>
    },
    {
        title: 'Equipment Age Score',
        name: 'equipment_age_score',
        order: 16,
        visible: true,
        length: "w-1/2",
        type: 'number',
        render: <Input disabled/>
    },
    {
        title: 'Visual Inspection Score',
        name: 'visual_inspection_score',
        order: 16,
        visible: true,
        length: "w-1/2",
        type: 'number',
        render: <Input disabled/>
    },
    {
        title: 'Deficiency Score',
        name: 'deficiency_score',
        order: 16,
        visible: true,
        length: "w-1/2",
        type: 'number',
        render: <Input disabled/>
    },
    {
        title: 'Score Updated Date',
        name: 'last_condition_update',
        order: 16,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input disabled/>
    },

    {
        title: 'Created By',
        name: 'createdby_name',
        order: 17,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input disabled/>
    },

    {
        title: 'Created Date',
        name: 'created_date',
        order: 18,
        visible: true,
        length: "w-1/2",
        type: 'Date',
        render: <Input disabled/>
    },
    {
        title: 'Modified By',
        name: 'lastModified_name',
        order: 19,
        visible: true,
        length: "w-1/2",
        type: 'text',
        render: <Input disabled/>
    },
    {
        title: 'Modified Date',
        name: 'modified_date',
        order: 20,
        visible: true,
        length: "w-1/2",
        type: 'Date',
        render: <Input disabled/>
    },

]
